// import star from 'src/assests/png/star.png'
import { Container, Typography } from "@cleartrip/ct-design-components";
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";

import Clevertap from "@/analytics/clevertap";
import HighRpsCheapestChip from "@/assets/svg/HighRpsCheapestChip";
import HighRpsDiscount from "@/assets/svg/HighRpsDiscount";
import HighRpsFlightIcon from '@/assets/svg/HighRpsFlightIcon';
import HighRpsLowestPrice from "@/assets/svg/HighRpsLowestPrice"
import HighRpsOffer from "@/assets/svg/HighRpsOffer";
import HighRpsStars from "@/assets/svg/HighRpsStars"
import HighRpsWheelIcon from "@/assets/svg/HighRpsWheelIcon"
import { SALE_CONFIG } from "@/constants/Sale";
import useVisibilityWithinTimeRange from "@/hooks/srp/useVisibilityWithinTimeRange";
import { formatCurrency } from "@/utils/general/browserHelper";

import ViewButon from "./ViewButton";

type propsType = {
    count: number
    highRpsDiscountedPrice: number,
    children: JSX.Element
    isPerAdult?: boolean,
}

const HighRpsNew = ({count, children, isPerAdult, highRpsDiscountedPrice}: propsType) => {
    const [animate, setAnimate] = useState(false)
    const [doAnimate, setDoAnimate] = useState(false);
    const isWithinTimeRange = useVisibilityWithinTimeRange( SALE_CONFIG.START_TIME, SALE_CONFIG.END_TIME)
    const isNewHighRps = isWithinTimeRange
    const firstTupleHeight = 140
    const cardsContainerRef = useRef<HTMLDivElement>(null);
    const cardsContainerHeight = cardsContainerRef.current?.clientHeight || firstTupleHeight


    useEffect(() => {
        setAnimate(() => false)
    }, [])
    const handleClick = () => {
        setAnimate((prev: boolean) => !prev);
        setDoAnimate(() => true);
        Clevertap.event('Air_UI_Action', {
            action_name: 'high_rps_flights_section_expanded',
            action_value: !animate ? 'expanded' : 'hided',
            high_rps_flights_count: count
        })
    }


    const outerDivStyle: React.CSSProperties = {
        marginLeft: animate || count === 1 ? '-8px' : '0px',
        marginRight:animate || count === 1 ? '-8px' : '0px',
        height:count > 1 && !doAnimate? isNewHighRps?"215px":"216px": "auto",
        border: '#3366CC1A solid 1px',
        backgroundColor: isNewHighRps ? '#FFD8CA' : '#EFF5FC',
        backgroundRepeat: 'no-repeat',
        padding: '16px 8px 32px 8px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        borderRadius: '4px',
        transitionDuration: '0.9s'
    }
    const root = document.documentElement;
    const staticHeight = isNewHighRps?140:114
    const slideUpHeight = isNewHighRps?245:198
    const slideDownHeight = isNewHighRps?226:196
    const tuppleFoldedHeight = isNewHighRps ? 125 : 104
    const dynamicheight = (cardsContainerHeight + staticHeight);
    root.style.setProperty('--totalTuple', dynamicheight + 'px')
    root.style.setProperty('--slideUpHeight', slideUpHeight + 'px')
    root.style.setProperty('--slideDownHeight', slideDownHeight + 'px')
    root.style.setProperty('--tuppleFoldedHeight', tuppleFoldedHeight + 'px')

    return (
        <Container style={{ marginBottom: '32px', marginTop: '16px', position: "relative" }}>
            <div
                className={count > 1 && doAnimate ? (animate ? 'animation ' : 'notAnimate ') : 'outer'}
                style={outerDivStyle}
            >
                {!isNewHighRps &&
                    <Container className='p-absolute' style={{ top: 0, right: 0 }}>
                    <HighRpsOffer />
                 </Container>}
                {isNewHighRps &&
                    <>
                        <Container className='p-absolute' style={{ top: 15, left: 0 }}>
                            <HighRpsWheelIcon/>
                    </Container>
                    <Container className='p-absolute' style={{ top: 15, right: 150 }}>
                            <HighRpsStars/>
                    </Container>
                    <Container className='p-absolute' style={{ top: 15, right: 90 }}>
                            <HighRpsFlightIcon/>
                    </Container>
                    {/* <Container className='p-absolute' style={{ top: 10, right: 10}}>
                        <Image src={"https://rukmini-ct.flixcart.com/f_auto,q_auto,w_60,h_60,dpr_2/staticresource-prod/images/NovacSale.png"} alt="novac" height={60} width={60}/>
                    </Container> */}
                    </>
                }
                <Container className="flex flex-middle pb-4 pl-4 gap-8">
                    {!isNewHighRps && <HighRpsDiscount />}

                    <Typography className="flex flex-middle" css={{fontSize: "20px", fontWeight: "600", lineHeight: "28px"}} variant="B1">
                        <>
                            {<Container className="mr-2 mt-2"><HighRpsLowestPrice/></Container>}
                            {!isNewHighRps && "Flights"} starting from {formatCurrency(highRpsDiscountedPrice)} {isPerAdult ? <span style={{color : '#808080', fontSize: "16px", fontWeight: "400"}}>/Adult</span> : ''}
                        </>
                    </Typography>
                    {!isNewHighRps && <HighRpsCheapestChip />}
                </Container>
                <Container className={count > 1 ? (animate ? 'tupleSlideDown o-hidden' : 'tupleSlideUp o-hidden') : ''} css={{zIndex: 1}} >
                    <Container ref={cardsContainerRef}>
                        {children}
                    </Container>
                </Container>
                {count > 1 && (
                    <Container className="flex flex-center p-absolute w-100p b--16">
                        <ViewButon
                            direction={!animate ? 'down' : 'up'}
                            handleClick={handleClick}
                            isNewHighRps={isNewHighRps}
                            tupleCount={count}
                        />
                    </Container>
                )}
            </div>
            {!animate && count > 1 && (
                <Container
                    className="modal"
                    css={{ zIndex: 2 }}
                    style={
                        isNewHighRps
                            ? {
                                  background:
                                      'linear-gradient(182.91deg, rgba(255, 255, 255, 0.2) 50%, #FFF1EC 97.58%)',
                                  opacity: '1',
                                  bottom: 0,
                                  width: '100%',
                                  pointerEvents: 'none'
                              }
                            : {
                                marginLeft: "8px"
                            }
                    }
                 />
            )}
        </Container>
    )
};

export default HighRpsNew;
